import functions from '@/functions.js';
import NavBar from '@/components/Nav.vue';

export default {
    name: 'SearchPage',
    components: {
        NavBar
    },
    data() {
        return {
            keyword: '',
            page: 1,
            more: true,
            loading: false,
            products: [],
            dateFormat: functions.dateFormat
        }
    },
    created() {
        this.keyword = this.$route.query.keyword;
        this.getProductList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getProductList() {
            if (this.keyword && this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('product', {params: {keyword: this.keyword, page: this.page}}).then(result => {
                    this.page++;
                    this.loading = false;
                    this.more = result.data.more;
                    this.products = this.products.concat(result.data.products);
                })
            }
        },
        submit() {
            this.page = 1;
            this.more = true;
            this.loading = false;
            this.products = [];
            this.getProductList();
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        }
    }
}